import './Link.scss';

import { AriaLinkProps } from '@react-types/link';
import { PressEvent } from '@react-types/shared';
import classnames from 'classnames';
import React, { useRef } from 'react';
import { useLink } from 'react-aria';

export interface LinkProps extends AriaLinkProps {
  href: string;
  target?: '_self' | '_blank' | '_parent' | '_top' | string;
  rel?: string;
  variant?: 'primary' | 'secondary' | 'tertiary' | 'ghost' | 'warning' | 'unstyled';
  children: React.ReactNode;
  size?: 'big' | 'normal' | 'small';
  className?: string;
  onClick?: (e: PressEvent) => void;
  onClickStart?: (e: PressEvent) => void;
  onClickEnd?: (e: PressEvent) => void;
  onClickChange?: (isPressed: boolean) => void;
  onClickUp?: (e: PressEvent) => void;
}

export function Link({ variant = 'unstyled', size = 'normal', className, children, href, rel, target, ...props }: LinkProps): React.ReactElement {
  const ref = useRef();

  const { linkProps } = useLink(props, ref);

  const classNames = classnames('link', size, variant, className, {
    [`${className}__link`]: !!className,
    [`${className}__link--${size}`]: !!className,
    [`${className}__link--${variant}`]: !!className && variant !== 'unstyled',
  });

  return (
    <a className={classNames} {...linkProps} ref={ref} href={href} target={target} rel={target === '_blank' ? 'noopener' : rel}>
      {children}
    </a>
  );
}
